import { Box, styled } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import { SAvatar, SDropdownMenu, SETVIImage } from '@setvi/shared/components';
import { getInitials } from 'Utils/getInitials';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import useDropdownDetails from './useDropdownDetails';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  padding: `3px ${theme.spacing(1)}px 3px 20px`,
  borderRadius: '32px',
  border: `1px solid ${theme.palette.grey[300]}`,
  [theme.breakpoints.down('md')]: {
    width: 'auto'
  }
}));

export const ProfileDropdown = () => {
  const { menuItems } = useDropdownDetails();
  const { user, companyData } = useAppContext();

  return (
    <SDropdownMenu menuItems={menuItems}>
      <StyledBox>
        <SETVIImage
          src={
            companyData?.webAppLogoUrl ||
            companyData?.iphonelogourl ||
            'https://setvi.azureedge.net/public/Setvi/Logos/PNG/SETVI-Horizontal-Logo-RGB-FullColor_Transparent1x.png'
          }
          alt="Company Logo"
          style={{ height: 40 }}
        />

        <ArrowDropDown />
        <SAvatar
          style={{ width: 40, height: 40 }}
          src={user.HasPhoto ? user.Photo : null}
          value={
            !user.HasPhoto
              ? getInitials({
                  firstName: user.FirstName,
                  lastName: user.LastName,
                  email: user.Email
                })
              : null
          }
        />
      </StyledBox>
    </SDropdownMenu>
  );
};
